import { ErrorHandler, Injectable } from '@angular/core';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class LoggingService implements ErrorHandler {
  constructor(private config: ConfigService) { }

  handleError(error): void {
    this.error(error.originalError || error);
  }

  error(error): void {
    console.error(error); // eslint-disable-line no-console
  }

  warn(...messages): void {
    console.warn(...messages); // eslint-disable-line no-console
  }

  debug(...messages): void {
    console.debug(...messages); // eslint-disable-line no-console
  }

  log(...messages): void {
    console.log(...messages); // eslint-disable-line no-console
  }
}
